/* @flow */
import routeForEndpoint from 'lib/routeForEndpoint';

export type ServiceUnavailableData = {
  expirationTime: number,
  message: string,
};

const routeExpirations: Map<string, ServiceUnavailableData> = new Map();

export function getServiceUnavailableData(endpoint: string): ?ServiceUnavailableData {
  const route = routeForEndpoint(endpoint);
  return routeExpirations.get(route);
}

export function clearRoute(endpoint: string): void {
  const route = routeForEndpoint(endpoint);
  routeExpirations.delete(route);
}

export function setRoute(endpoint: string, expirationTime: number, message: string) {
  const route = routeForEndpoint(endpoint);

  routeExpirations.set(route, {
    expirationTime,
    message,
  });
}
